import React, { useState, useEffect } from "react"
import {
  Col,
  Row,
  UncontrolledAlert,
  Spinner,
} from "reactstrap"
import api from "API/Api"
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation"
import { Link, useParams } from "react-router-dom"

const EditVendor = props => {
  const { id } = useParams()
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [dataLoaded, setDataLoaded] = useState(false)
  const [companies, setCompanies] = useState([])
  const [plants, setPlants] = useState([])
  const [allPlants, setAllPlants] = useState([])
  const [states, setStates] = useState([])
  const [districts, setDistricts] = useState([])
  const [centers, setCenters] = useState([])
  const [allCenters, setAllCenters] = useState([])
  const [routes, setRoutes] = useState([])
  const [allRoutes, setAllRoutes] = useState([])
  const [vehicles, setVehicles] = useState([])
  const [vendor, setVendor] = useState({})
  const [selectedCompany, setSelectedCompany] = useState("")
  const [selectedPlant, setSelectedPlant] = useState("")
  const [selectedCC, setSelectedCC] = useState("")
  const [paymentMode, setPaymentMode] = useState("")

  const multipleCompanies = companies.length > 1

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
      const create = await api.put("update-vendor/" + id, values)
      if (create.data.success === true) setSubmitted(true)
    } catch (error) {
      // Handled by global interceptor
    }
    setLoading(false)
  }

  useEffect(() => {
    getInfo()
  }, [])

  const getInfo = async () => {
    try {
      const [vendorResp, compResp, plantResp, cenResp, routeResp, stateResp, vehResp] = await Promise.all([
        api.get("vendor/" + id),
        api.get("companies"),
        api.get("plants"),
        api.get("centers"),
        api.get("routes"),
        api.get("states"),
        api.get("vehicles").catch(() => ({ data: { data: [] } }))
      ])
      const v = vendorResp.data.data[0] || {}
      const comp = Array.isArray(compResp.data.data) ? compResp.data.data : compResp.data.data?.data || []
      const plt = Array.isArray(plantResp.data.data) ? plantResp.data.data : plantResp.data.data?.data || []
      const cen = Array.isArray(cenResp.data.data) ? cenResp.data.data : cenResp.data.data?.data || []
      const rte = Array.isArray(routeResp.data.data) ? routeResp.data.data : routeResp.data.data?.data || []
      const st = Array.isArray(stateResp.data.data) ? stateResp.data.data : stateResp.data.data?.data || []
      const veh = Array.isArray(vehResp.data.data) ? vehResp.data.data : vehResp.data.data?.data || []

      setVendor(v)
      setCompanies(comp)
      setAllPlants(plt); setPlants(plt)
      setAllCenters(cen); setCenters(cen)
      setAllRoutes(rte); setRoutes(rte)
      setStates(st)
      setVehicles(veh)

      // Figure out company from CC → Plant → Company
      const vendorCC = cen.find(c => String(c.id) === String(v.chillingCenter))
      if (vendorCC) {
        const vendorPlant = plt.find(p => String(p.id) === String(vendorCC.plant_id))
        if (vendorPlant) {
          setSelectedCompany(String(vendorPlant.company_id))
          setSelectedPlant(String(vendorPlant.id))
        }
      }
      setSelectedCC(String(v.chillingCenter || ""))
      setPaymentMode(String(v.paymentMode || ""))

      // Load districts for vendor's state
      if (v.state) {
        try {
          const dists = await api.get("districts/" + v.state)
          setDistricts(Array.isArray(dists.data.data) ? dists.data.data : dists.data.data?.data || [])
        } catch (e) { setDistricts([]) }
      }
      setDataLoaded(true)
    } catch (e) { console.error(e); setDataLoaded(true) }
  }

  // Cascading: Company → Plants
  const handleCompanyChange = (e) => {
    const compId = e.target.value
    setSelectedCompany(compId)
    setSelectedPlant(""); setSelectedCC("")
    if (compId) {
      const fp = allPlants.filter(p => String(p.company_id) === String(compId))
      setPlants(fp)
      const plantIds = fp.map(p => String(p.id))
      setCenters(allCenters.filter(c => plantIds.includes(String(c.plant_id))))
      setRoutes(allRoutes)
    } else {
      setPlants(allPlants); setCenters(allCenters); setRoutes(allRoutes)
    }
  }

  // Cascading: Plant → CCs
  const handlePlantChange = (e) => {
    const plantId = e.target.value
    setSelectedPlant(plantId); setSelectedCC("")
    if (plantId) {
      setCenters(allCenters.filter(c => String(c.plant_id) === String(plantId)))
    } else {
      if (selectedCompany) {
        const fp = allPlants.filter(p => String(p.company_id) === String(selectedCompany))
        const plantIds = fp.map(p => String(p.id))
        setCenters(allCenters.filter(c => plantIds.includes(String(c.plant_id))))
      } else {
        setCenters(allCenters)
      }
    }
  }

  // Cascading: CC → Routes
  const handleCCChange = (e) => {
    const ccId = e.target.value
    setSelectedCC(ccId)
    if (ccId) {
      setRoutes(allRoutes.filter(r => String(r.chillingCenter) === String(ccId)))
    } else {
      setRoutes(allRoutes)
    }
  }

  const stateChangeHandler = async e => {
    try {
      const distResp = await api.get("districts/" + e.target.value)
      setDistricts(Array.isArray(distResp.data.data) ? distResp.data.data : distResp.data.data?.data || [])
    } catch (e) { setDistricts([]) }
  }

  if (!dataLoaded) return <div className="dashBody"><div className="text-center p-5"><Spinner color="primary" /></div></div>

  return (
    <>
      <div className="dashBody">
        <div className="font-size-18 mb-0 dashHeader" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h4 style={{ margin: 0 }}>Edit Vendor</h4>
          <Link to="/bulk-vendors" style={{ width: "32px", height: "32px", borderRadius: "4px", background: "#6c757d", color: "#fff",
            display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "14px", textDecoration: "none" }}>
            <i className="fas fa-arrow-left"></i>
          </Link>
        </div>
        <div className="dashContent">
          <AvForm
            style={{ position: "relative" }}
            className="form-horizontal mt-4"
            onValidSubmit={(e, v) => { handleValidSubmit(e, v) }}
          >
            {/* ── Section: Location ── */}
            <div style={{ border: "1px solid #e2e8f0", borderRadius: "8px", padding: "16px", marginBottom: "16px", background: "#f8fafc" }}>
              <h6 style={{ color: "#6366f1", marginBottom: "12px", fontSize: "14px" }}>
                <i className="fas fa-map-marker-alt me-2"></i>Location & Assignment
              </h6>
              <Row>
                {multipleCompanies && (
                  <Col md={6}>
                    <div className="mb-3">
                      <label className="form-label">Company</label>
                      <select className="form-control" value={selectedCompany} onChange={handleCompanyChange}>
                        <option value="">Select</option>
                        {companies.map((c, i) => <option key={i} value={c.id}>{c.name}</option>)}
                      </select>
                    </div>
                  </Col>
                )}
                <Col md={6}>
                  <div className="mb-3">
                    <label className="form-label">Plant *</label>
                    <select className="form-control" value={selectedPlant} onChange={handlePlantChange}>
                      <option value="">Select</option>
                      {plants.map((p, i) => <option key={i} value={p.id}>{p.name}</option>)}
                    </select>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <AvField type="select" name="chillingCenter" label="Chilling Center *" required
                      value={vendor.chillingCenter} onChange={handleCCChange}>
                      <option value="">Select</option>
                      {centers.map((c, i) => <option key={i} value={c.id}>{c.name}</option>)}
                    </AvField>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <AvField type="select" name="route" label="Route *" required value={vendor.route}>
                      <option value="">Select</option>
                      {routes.map((r, i) => <option key={i} value={r.id}>{r.routeName}</option>)}
                    </AvField>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <AvField type="select" name="procurementType" value={vendor.procurementType} label="Operation Type *" required>
                      <option value="">Select</option>
                      <option value="3rd Party Collection">3rd Party Collection</option>
                      <option value="Own Farm">Own Farm</option>
                      <option value="RMC Producer">RMC Producer</option>
                    </AvField>
                  </div>
                </Col>
              </Row>
            </div>

            {/* ── Section: Vendor Info ── */}
            <div style={{ border: "1px solid #e2e8f0", borderRadius: "8px", padding: "16px", marginBottom: "16px", background: "#f8fafc" }}>
              <h6 style={{ color: "#6366f1", marginBottom: "12px", fontSize: "14px" }}>
                <i className="fas fa-user me-2"></i>Vendor Information
              </h6>
              <Row>
                <Col md={6}><div className="mb-3"><AvField name="vendorName" label="Vendor Name *" value={vendor.vendorName} type="text" required /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="vendorNumber" label="Vendor Number *" value={vendor.vendorNumber} type="text" required /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="canNumber" label="Can Number" value={vendor.canNumber} type="text" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="door" label="Door No" value={vendor.door} type="text" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="village" label="Village Name" value={vendor.village} type="text" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="taluk" label="Taluk Name" value={vendor.taluk} type="text" /></div></Col>
                <Col md={6}>
                  <div className="mb-3">
                    <AvField type="select" name="state" value={vendor.state} label="State" onChange={e => stateChangeHandler(e)}>
                      <option value="">Select State</option>
                      {states.map((s, i) => <option key={i} value={s.id}>{s.state}</option>)}
                    </AvField>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <AvField type="select" name="district" label="District" value={vendor.district}>
                      <option value="">Select District</option>
                      {districts.map((d, i) => <option key={i} value={d.id}>{d.district}</option>)}
                    </AvField>
                  </div>
                </Col>
                <Col md={6}><div className="mb-3"><AvField name="pincode" label="Pincode" value={vendor.pincode} type="text" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="gstIN" label="GSTIN" value={vendor.gstIN} type="text" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="vendorMobile" label="Vendor Mobile" value={vendor.venodrMobile || vendor.vendorMobile} type="text" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="vendorEmail" label="Vendor Email" value={vendor.vendorEmail || ""} type="email" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="vendorAadhar" label="Vendor Aadhaar" value={vendor.venodrAadhar || vendor.vendorAadhar} type="text" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="vendorPAN" label="Vendor PAN" value={vendor.venodrPAN || vendor.vendorPAN} type="text" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="supervisor" label="Supervisor" value={vendor.supervisor} type="text" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="remarks" label="Remarks" value={vendor.remarks || ""} type="textarea" /></div></Col>
              </Row>
            </div>

            {/* ── Section: Rate & Payment ── */}
            <div style={{ border: "1px solid #e2e8f0", borderRadius: "8px", padding: "16px", marginBottom: "16px", background: "#f8fafc" }}>
              <h6 style={{ color: "#6366f1", marginBottom: "12px", fontSize: "14px" }}>
                <i className="fas fa-rupee-sign me-2"></i>Rate Chart & Payment
              </h6>
              <Row>
                <Col md={6}>
                  <div className="mb-3">
                    <AvRadioGroup inline name="rateChartType" value={vendor.rateChartType} label="Rate Chart Type *" required errorMessage="Pick one!">
                      <AvRadio label="Common" value="0" />
                      <AvRadio label="Separate" value="1" />
                    </AvRadioGroup>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <AvRadioGroup inline name="paymentMode" value={vendor.paymentMode} label="Payment Mode *" required errorMessage="Pick one!"
                      onChange={(e, val) => setPaymentMode(val)}>
                      <AvRadio label="Cash" value="0" />
                      <AvRadio label="Bank Account" value="1" />
                    </AvRadioGroup>
                  </div>
                </Col>
              </Row>
            </div>

            {/* ── Section: Document Uploads ── */}
            <div style={{ border: "1px solid #e2e8f0", borderRadius: "8px", padding: "16px", marginBottom: "16px", background: "#f8fafc" }}>
              <h6 style={{ color: "#6366f1", marginBottom: "12px", fontSize: "14px" }}>
                <i className="fas fa-file-alt me-2"></i>Document Uploads <span style={{ fontSize: "11px", color: "#94a3b8", fontWeight: "normal" }}>(Optional)</span>
              </h6>
              <Row>
                <Col md={4}><div className="mb-3"><label className="form-label">Upload Aadhaar Copy</label><input type="file" className="form-control" name="aadhaarCopy" /></div></Col>
                <Col md={4}><div className="mb-3"><label className="form-label">Upload PAN Copy</label><input type="file" className="form-control" name="panCopy" /></div></Col>
                <Col md={4}><div className="mb-3"><label className="form-label">Upload Bank Passbook/Statement</label><input type="file" className="form-control" name="bankPassbook" /></div></Col>
              </Row>
            </div>

            {/* ── Section: CC Purchase Settings ── */}
            <div style={{ border: "1px solid #e2e8f0", borderRadius: "8px", padding: "16px", marginBottom: "16px", background: "#f8fafc" }}>
              <h6 style={{ color: "#6366f1", marginBottom: "12px", fontSize: "14px" }}>
                <i className="fas fa-cogs me-2"></i>CC Purchase Settings
              </h6>
              <Row>
                <Col md={6}>
                  <div className="mb-3">
                    <AvRadioGroup inline name="cowMilkCcPurchase" value={vendor.cowMilkCcPurchase} label="Incentive Available for Cow Milk in CC Purchase?" required errorMessage="Pick one!">
                      <AvRadio label="Yes" value="1" />
                      <AvRadio label="No" value="0" />
                    </AvRadioGroup>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <AvRadioGroup inline name="buffaloMilkCcPurchase" value={vendor.buffaloMilkCcPurchase} label="Incentive Available for Buffalo Milk in CC Purchase?" required errorMessage="Pick one!">
                      <AvRadio label="Yes" value="1" />
                      <AvRadio label="No" value="0" />
                    </AvRadioGroup>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <AvField type="select" name="pickupVehicle" value={vendor.pickupVehicle} label="Pickup Vehicle">
                      <option value="">Select</option>
                      {vehicles.map((v, i) => <option key={i} value={v.id}>{v.vehicleNumber || v.name || v.id}</option>)}
                    </AvField>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <AvRadioGroup inline name="limitVendorCc" value={vendor.limitVendorCc} label="Limit Single Entry by Milk Type for this vendor in CC *" required errorMessage="Pick one!">
                      <AvRadio label="Yes" value="1" />
                      <AvRadio label="No" value="0" />
                    </AvRadioGroup>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <label className="form-label">Applicable Milk Types in CC *</label>
                    <div style={{ display: "flex", gap: "16px" }}>
                      <div className="form-check">
                        <input className="form-check-input" type="checkbox" name="milkTypeCow" id="milkTypeCowEdit" defaultChecked />
                        <label className="form-check-label" htmlFor="milkTypeCowEdit">Cow</label>
                      </div>
                      <div className="form-check">
                        <input className="form-check-input" type="checkbox" name="milkTypeBuffalo" id="milkTypeBuffaloEdit" defaultChecked />
                        <label className="form-check-label" htmlFor="milkTypeBuffaloEdit">Buffalo</label>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <AvRadioGroup inline name="milkTypeCc" value={vendor.milkTypeCc} label="Default Milk Type in CC" required errorMessage="Pick one!">
                      <AvRadio label="Cow" value="1" />
                      <AvRadio label="Buffalo" value="2" />
                      <AvRadio label="None" value="0" />
                    </AvRadioGroup>
                  </div>
                </Col>
              </Row>
            </div>

            {/* ── Section: Export & SMS ── */}
            <div style={{ border: "1px solid #e2e8f0", borderRadius: "8px", padding: "16px", marginBottom: "16px", background: "#f8fafc" }}>
              <h6 style={{ color: "#6366f1", marginBottom: "12px", fontSize: "14px" }}>
                <i className="fas fa-paper-plane me-2"></i>Export & SMS
              </h6>
              <Row>
                <Col md={4}><div className="mb-3"><AvField name="parameter1" label="Export Parameter 1" value={vendor.parameter1} type="text" /></div></Col>
                <Col md={4}><div className="mb-3"><AvField name="parameter2" label="Export Parameter 2" value={vendor.parameter2} type="text" /></div></Col>
                <Col md={4}><div className="mb-3"><AvField name="parameter3" label="Export Parameter 3" value={vendor.parameter3} type="text" /></div></Col>
                <Col md={6}>
                  <div className="mb-3">
                    <AvRadioGroup inline name="smsCcPurchases" value={vendor.smsCcPurchases} label="Send SMS for CC Purchases *" required errorMessage="Pick one!">
                      <AvRadio label="Yes" value="1" />
                      <AvRadio label="No" value="0" />
                    </AvRadioGroup>
                  </div>
                </Col>
              </Row>
            </div>

            {/* ── Bank Details (Shown when Bank Account selected) ── */}
            <div style={{
              border: paymentMode === "1" ? "1px solid #6366f1" : "1px solid #e2e8f0",
              borderRadius: "8px", padding: paymentMode === "1" ? "16px" : "0 16px",
              marginBottom: "16px", background: paymentMode === "1" ? "#f8fafc" : "transparent",
              maxHeight: paymentMode === "1" ? "500px" : "0",
              overflow: "hidden", opacity: paymentMode === "1" ? 1 : 0,
              transition: "all 0.35s ease-in-out"
            }}>
              <h6 style={{ color: "#6366f1", marginBottom: "12px", fontSize: "14px" }}>
                <i className="fas fa-university me-2"></i>Bank Account Details <span style={{ fontSize: "11px", color: "#ef4444", fontWeight: "normal" }}>( Required for Bank Payment )</span>
              </h6>
              <Row>
                <Col md={4}><div className="mb-3"><AvField name="bank_ifsc" label="Bank Branch IFSC *" type="text" value={vendor.bank_ifsc || ""} placeholder="e.g. SBIN0001234" required={paymentMode === "1"} /></div></Col>
                <Col md={4}><div className="mb-3"><AvField name="bank_name" label="Bank Name *" type="text" value={vendor.bank_name || ""} placeholder="e.g. State Bank of India" required={paymentMode === "1"} /></div></Col>
                <Col md={4}><div className="mb-3"><AvField name="bank_branch" label="Bank Branch Name *" type="text" value={vendor.bank_branch || ""} required={paymentMode === "1"} /></div></Col>
              </Row>
              <Row>
                <Col md={4}><div className="mb-3"><AvField name="bank_account_number" label="Bank Account Number *" type="text" value={vendor.bank_account_number || ""} required={paymentMode === "1"} /></div></Col>
                <Col md={4}><div className="mb-3"><AvField name="bank_account_name" label="Bank Account Name *" type="text" value={vendor.bank_account_name || ""} required={paymentMode === "1"} /></div></Col>
                <Col md={4}><div className="mb-3"><AvField name="upi_id" label="UPI ID" type="text" value={vendor.upi_id || ""} placeholder="e.g. name@upi" /></div></Col>
              </Row>
            </div>

            <div className="mb-3 row mt-4">
              <div className="col-6">
                {submitted ? (
                  <UncontrolledAlert color="success">
                    <strong>Vendor is Updated!</strong>
                  </UncontrolledAlert>
                ) : null}
              </div>
              <div className="col-6 text-end">
                <button className="btn btn-primary w-md waves-effect waves-light" type="submit" disabled={loading}>
                  {loading ? (
                    <><Spinner animation="border" size="sm" /><span style={{ paddingLeft: "10px" }}>Updating...</span></>
                  ) : (
                    <span>Update Vendor</span>
                  )}
                </button>
              </div>
            </div>
          </AvForm>
        </div>
      </div>
    </>
  )
}

export default EditVendor
